module.exports = __webpack_public_path__ + "img/IMG_2513-2-2.94960e13.jpg";